import React, { useEffect, useState, useCallback } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { MapPin, Users, Globe, TrendingUp } from 'lucide-react';
import { authedAxios } from './api';

export default function AnalyticsView() {
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await authedAxios().get('/admin/analytics');
      setAnalytics(data);
    } catch (e) {
      console.error('analytics', e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [load]);

  if (loading && !analytics) return <div className="py-12 text-center text-gray-600">Loading analytics…</div>;
  if (!analytics) return <div className="py-12 text-center text-gray-600">No analytics data available</div>;

  return (
    <div className="space-y-6" data-testid="analytics-view">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Card><CardContent className="p-4 flex items-center justify-between">
          <div><p className="text-xs text-gray-500">Total Visits</p>
            <p className="text-2xl font-bold" data-testid="total-visits">{analytics.total_visits}</p></div>
          <Users className="h-8 w-8 text-green-600" />
        </CardContent></Card>
        <Card><CardContent className="p-4 flex items-center justify-between">
          <div><p className="text-xs text-gray-500">Countries</p>
            <p className="text-2xl font-bold">{Object.keys(analytics.visits_by_country).length}</p></div>
          <Globe className="h-8 w-8 text-blue-600" />
        </CardContent></Card>
        <Card><CardContent className="p-4 flex items-center justify-between">
          <div><p className="text-xs text-gray-500">Cities</p>
            <p className="text-2xl font-bold">{Object.keys(analytics.visits_by_city).length}</p></div>
          <MapPin className="h-8 w-8 text-purple-600" />
        </CardContent></Card>
        <Card><CardContent className="p-4 flex items-center justify-between">
          <div><p className="text-xs text-gray-500">Status</p>
            <p className="text-lg font-bold text-green-600">Live</p></div>
          <TrendingUp className="h-8 w-8 text-green-600" />
        </CardContent></Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Card><CardContent className="p-4">
          <h3 className="font-bold mb-3">Visits by City</h3>
          <div className="space-y-2 text-sm">
            {Object.entries(analytics.visits_by_city).sort((a, b) => b[1] - a[1]).slice(0, 10).map(([k, v]) => (
              <div key={k} className="flex justify-between"><span className="text-gray-700">{k}</span><span className="font-semibold">{v}</span></div>
            ))}
          </div>
        </CardContent></Card>
        <Card><CardContent className="p-4">
          <h3 className="font-bold mb-3">Recent Visits</h3>
          <div className="space-y-1 text-xs max-h-72 overflow-y-auto">
            {analytics.recent_visits.map((v, i) => (
              <div key={`${v.timestamp || 'na'}-${i}`} className="flex justify-between border-b border-gray-100 py-1">
                <span className="text-gray-600">{v.timestamp ? new Date(v.timestamp).toLocaleString() : '—'}</span>
                <span className="text-gray-900">{v.city}, {v.country}</span>
              </div>
            ))}
          </div>
        </CardContent></Card>
      </div>
    </div>
  );
}
